import React, { Component } from 'react';
import { Col, Row, ControlLabel, FormGroup } from 'react-bootstrap';
import { Control } from 'react-redux-form';
import RequiredRadioGroup from '../../../../components/common/form/elements/required-radio-group';
import TextInput from '../../../../components/common/form/elements/text-input';

class AuditAmount extends Component {
  render() {
    const {
      onBlur, isAuditCompleted, hasIncentiveId, hasPostcodeplanObjectivesId, status, auditAmounts,
      statusOptions, categoryAuditAmounts, categoryNumberOfPacksSold, isDeclined, isAudit
    } = this.props;

    return (
      <div>
        <Row>
          <Col md={12}>
            {hasIncentiveId && (
              <TextInput
                onBlur={onBlur}
                label='Audit Amount'
                model='.audit_amount'
                required={isAuditCompleted || isAudit}
                disabled={['APPROVED', 'DECLINED'].includes(status)}
              />
            )}
            {hasPostcodeplanObjectivesId && auditAmounts && (
              <div>
                  Audit amount: <br></br>
                  Number of packs sold
                  {categoryAuditAmounts.map((categoryAuditAmount, index) => (
                    categoryNumberOfPacksSold[index].value !== null && (
                      <Row key={index}>
                        <Col md={2} style={{ marginTop: 10 }}>
                          {categoryAuditAmount.label}
                        </Col>
                        <Col md={8}>
                          <TextInput
                            model={`.category_audit_amounts.${index}.value`}
                            disabled={['VALIDATED', 'DECLINED'].includes(status)}
                          />
                        </Col>
                      </Row>
                    )
                  ))}
                  {auditAmounts.map((auditAmount, index) => (
                    <Row key={index}>
                      <Col md={2} style={{ marginTop: 10 }}>
                        {auditAmount.label}
                      </Col>
                      <Col md={8}>
                        <TextInput
                          onBlur={onBlur}
                          model={`.brand_audit_amounts.${index}.value`}
                          disabled={['VALIDATED', 'DECLINED'].includes(status)}
                        />
                      </Col>
                    </Row>
                  ))}
              </div>
              )}
          </Col>
        </Row>
        {hasIncentiveId && !isAudit && (
          <Row>
            <Col md={12}>
              <FormGroup>
                <ControlLabel>
                  Submission approved?*
                </ControlLabel>
                <RequiredRadioGroup
                  model='.status'
                  controlId='status'
                  radios={statusOptions}
                  inline
                />
              </FormGroup>
            </Col>
          </Row>
          )}
        {isDeclined && (
          <Row>
            <Col md={12}>
              <FormGroup>
                <ControlLabel>
                  Decline Reason
                </ControlLabel>
                <Control.text
                  label='Decline Reason'
                  model='.decline_reason'
                />
              </FormGroup>
            </Col>
          </Row>
          )}
      </div>
    );
  }
}

export default AuditAmount;



// WEBPACK FOOTER //
// ./src/components/admin/submissions/form/audit-amount.jsx